import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';
import { Select, MenuItem, FormControl } from '@mui/material';

export function LanguageSwitch() {
  const { language, changeLanguage } = useLanguage();

  return (
    <FormControl>
      <Select
        value={language}
        onChange={(e) => changeLanguage(e.target.value as 'fr' | 'en')}
        size="small"
        sx={{
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            pr: 4,
            py: 1,
            color: 'inherit'
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none'
          }
        }}
      >
        <MenuItem value="fr" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Globe size={16} /> FR
        </MenuItem>
        <MenuItem value="en" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Globe size={16} /> EN
        </MenuItem>
      </Select>
    </FormControl>
  );
}